<template lang="pug">
  #chapter1
    Intro
    Navbar
    Section1
    Section2
    Section3
    Section4
    Section5
    Section6
    Section7
</template>

<script>
// @ is an alias to /src
import Intro from "@/components/chapter1/Intro.vue";
import Navbar from "@/components/chapter1/Navbar.vue";
import Section1 from "@/components/chapter1/Section1.vue";
import Section2 from "@/components/chapter1/Section2.vue";
import Section3 from "@/components/chapter1/Section3.vue";
import Section4 from "@/components/chapter1/Section4.vue";
import Section5 from "@/components/chapter1/Section5.vue";
import Section6 from "@/components/chapter1/Section6.vue";
import Section7 from "@/components/chapter1/Section7.vue";

export default {
  name: "Chapter1",
  components: {
    Intro,
    Navbar,
    Section1,
    Section2,
    Section3,
    Section4,
    Section5,
    Section6,
    Section7
  },
  computed: {
    sectionId: {
      get() {
        return this.$store.state.chapter1.sectionId;
      },
      set(value) {
        this.$store.state.chapter1.sectionId = value;
      }
    }
  },
  methods: {
    headerObserver() {
      let previousY = 0;
      //let previousRatio = 0;
      let currentY = window.scrollY;
      let options = {
        root: null,
        rootMargin: "0px",
        threshold: [0, 1]
      };
      let slideEffect = entries => {
        entries.forEach(entry => {
          previousY = currentY;
          currentY = window.scrollY;
          const scrollingDown = currentY > previousY,
            elementExits =
              !entry.isIntersecting && entry.intersectionRatio == 0,
            text = document.querySelector(
              "#" + entry.target.parentNode.id + " .slide p"
            );

          if (scrollingDown) {
            if (entry.isIntersecting) {
              if (text) text.classList.remove("show");
              if (entry.intersectionRatio == 1) this.menuEffect(entry.target);
            } else if (text) text.classList.add("show");
          } else if (text) {
            entry.isIntersecting || elementExits
              ? text.classList.remove("show")
              : text.classList.add("show");
          }
        });
      };
      let targets = document.querySelectorAll(".fake-header");
      let observer = new IntersectionObserver(slideEffect, options);

      targets.forEach(t => {
        observer.observe(t);
      });
    },
    footerObserver() {
      let previousY = 0;
      let currentY = window.scrollY;
      let options = {
        root: null,
        rootMargin: "0px",
        threshold: [0, 1]
      };
      let slideEffect = entries => {
        entries.forEach(entry => {
          previousY = currentY;
          currentY = window.scrollY;
          const scrollingDown = currentY > previousY,
            elementExits =
              !entry.isIntersecting && entry.intersectionRatio == 0,
            text = document.querySelector(
              "#" + entry.target.parentNode.id + " .slide p"
            );

          /* console.log("intersectionRatio ", entry.intersectionRatio);   // Which of threshold triggered
          console.log("isIntersecting ", entry.isIntersecting);   // true == visible
          console.log("target ", entry.target);   // Entry element
          console.log("time ", entry.time); // time in entry
          console.log("previous Y", previousY, " current Y", window.scrollY );
          console.log("scrolling down ", previousY < window.scrollY);
          console.log("hide condition aditional", entry.isIntersecting || !entry.isIntersecting && entry.intersectionRatio == 0);
          console.log('window scroll y ', window.scrollY);
          console.log("--------------------------------"); */

          if (scrollingDown && text) {
            entry.isIntersecting || elementExits
              ? text.classList.remove("show")
              : text.classList.add("show");
          } else if (!scrollingDown) {
            if (entry.isIntersecting) {
              if (text) text.classList.remove("show");
              if (entry.intersectionRatio == 1) this.menuEffect(entry.target);
            } else if (text) text.classList.add("show");
          }
        });
      };

      let targets = document.querySelectorAll(".fake-footer");
      let observer = new IntersectionObserver(slideEffect, options);
      targets.forEach(t => {
        observer.observe(t);
      });
    },
    menuEffect(element) {
      this.sectionId = element.parentNode.parentNode.parentNode.id;
    },
    clearText() {
      setTimeout(() => {
        document
          .querySelectorAll(".slide p")
          .forEach(p => p.classList.remove("show"));
      }, 1000);
    },
    // scrollToAnchor(hashbang) {
    //   location.hash = hashbang;
    // },
    async initialize() {
      // if (this.$route.hash === '#intro') {
      //   setTimeout(() => this.scrollToAnchor(this.$route.hash), 1);
      // }
      await this.headerObserver();
      await this.footerObserver();
      this.clearText();
    }
  },
  async mounted() {
    await this.initialize();
  }
};
</script>
